<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.group_index,
                    },
                    {
                        name: group.name,
                        href: meta.links.group_show,
                    },
                    {
                        name: $tc('messages.teams', 2),
                        href: null,
                    },
                ]"
            />
        </template>
        <TeamGeneratorPage
            :teams="teams"
            :grouping="grouping"
            :students-not-in-team="group.students"
            :all-students="allStudents"
            :links="meta.links"
            :info="meta.info"
            :table="meta.info.table"
            :groupings="options.groupings"
            :sociogram-survey="sociogramSurvey"
        />
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import TeamGeneratorPage from './partials/TeamGeneratorPage.vue';
import PanelPage from '@/Shared/PanelPage.vue';

export default {
    components: {
        TeamGeneratorPage,
        PanelPage,
    },
    layout: Layout,
    name: 'Edit',
    props: ['filters', 'meta', 'options', 'group', 'grouping', 'teams', 'allStudents', 'sociogramSurvey'],
};
</script>
